import {
  Box,
  Flex,
  Stat,
  StatLabel,
  Text,
  Grid,
  GridItem,
  Button,
  useDisclosure,
  Table,
  Tbody,
  Td,
  Tr,
  TableContainer,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Thead,
  Th,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton
} from '@chakra-ui/react'
import { FC, useState } from 'react'
import Chart from 'react-apexcharts'
import { FaEye } from 'react-icons/fa'

import useOptimizerStorange from '@hook/optimizer/use-optimizer-storange'

import LayoutEmpty from '@component/Layout/Empty'
import LayoutLoader from '@component/Layout/Loader'

import { formatPercent, formatToBRL } from '@helper/grid/strings'

import ParametrosTable from './General/Default'
import TradeOffResumeTable from './General/SummaryTable'
import HistoricOtptimizer from './Historic'
import Core2Otimizador from './SecondView'
import SelectedTableBar from './SelectedTableBar'
import Core3Otimizador from './TreeView'
// const data = [
//   {
//     'Codigo Nivel': 'Empresa',
//     Nivel: 5489229,
//     'Est Realizado': 0.99,
//     'Nivel Real': 239244,
//     'Est Medio': 0.85
//   },
//   {
//     'Codigo Nivel': 'Curva A',
//     Nivel: 282424,
//     'Est Realizado': 0.89,
//     'Nivel Real': 131331,
//     'Est Medio': 0.34
//   },
//   {
//     'Codigo Nivel': 'Curva B',
//     Nivel: 13131,
//     'Est Realizado': 0.45,
//     'Nivel Real': 13131,
//     'Est Medio': 0.45
//   },
//   {
//     'Codigo Nivel': 'Curva C',
//     Nivel: 134425,
//     'Est Realizado': 0.89,
//     'Nivel Real': 31313,
//     'Est Medio': 0.65
//   },
//   {
//     'Codigo Nivel': 'Curva D',
//     Nivel: 13131,
//     'Est Realizado': 0.89,
//     'Nivel Real': 13131,
//     'Est Medio': 0.678
//   }
// ]

// const dataOne = [
//   {
//     'Categoria Compac': 'MDf',
//     'Curva Abc': 'D',
//     'Estoq Medio Realiz': 13,
//     'Nivel de Serv Realizado': 99,
//     'estoque medio otim': 5999,
//     'Nivel de Servico Otimi': 98,
//     'Variacao Estoque medio': 600,
//     'Variacao nivel de Ser': -0.89,
//     'Nivel Desejado': 0,
//     'Id Categoria': 1
//   },
//   {
//     'Categoria Compac': 'Mdf branco',
//     'Curva Abc': 'D',
//     'Estoq Medio Realiz': 1313,
//     'Nivel de Serv Realizado': 92,
//     'estoque medio otim': 31313,
//     'Nivel de Servico Otimi': 98,
//     'Variacao Estoque medio': 3131,
//     'Variacao nivel de Ser': -0.89,
//     'Nivel Desejado': 0,
//     'Id Categoria': 2
//   },
//   {
//     'Categoria Compac': 'Mdf raiz',
//     'Curva Abc': 'B',
//     'Estoq Medio Realiz': 414,
//     'Nivel de Serv Realizado': 94,
//     'estoque medio otim': 1313,
//     'Nivel de Servico Otimi': 97,
//     'Variacao Estoque medio': 1312,
//     'Variacao nivel de Ser': -0.89,
//     'Nivel Desejado': 0,
//     'Id Categoria': 3
//   },
//   {
//     'Categoria Compac': 'Mdf',
//     'Curva Abc': 'C',
//     'Estoq Medio Realiz': 3144,
//     'Nivel de Serv Realizado': 92,
//     'estoque medio otim': 13131,
//     'Nivel de Servico Otimi': 4,
//     'Variacao Estoque medio': 4353,
//     'Variacao nivel de Ser': 12,
//     'Nivel Desejado': 0,
//     'Id Categoria': 4
//   },
//   {
//     'Categoria Compac': 'Madeiras',
//     'Curva Abc': 'D',
//     'Estoq Medio Realiz': 123,
//     'Nivel de Serv Realizado': 98,
//     'estoque medio otim': 11214,
//     'Nivel de Servico Otimi': 29,
//     'Variacao Estoque medio': 1313,
//     'Variacao nivel de Ser': 1,
//     'Nivel Desejado': 0,
//     'Id Categoria': 5
//   },
//   {
//     'Categoria Compac': 'Comparcado',
//     'Curva Abc': 'A',
//     'Estoq Medio Realiz': 1,
//     'Nivel de Serv Realizado': 90,
//     'estoque medio otim': 2424,
//     'Nivel de Servico Otimi': 23,
//     'Variacao Estoque medio': 5353,
//     'Variacao nivel de Ser': 2,
//     'Nivel Desejado': 1,
//     'Id Categoria': 6
//   },
//   {
//     'Categoria Compac': 'Mdf raiz',
//     'Curva Abc': 'B',
//     'Estoq Medio Realiz': 414,
//     'Nivel de Serv Realizado': 94,
//     'estoque medio otim': 1313,
//     'Nivel de Servico Otimi': 97,
//     'Variacao Estoque medio': 1312,
//     'Variacao nivel de Ser': -0.89,
//     'Nivel Desejado': 0,
//     'Id Categoria': 3
//   },
//   {
//     'Categoria Compac': 'Mdf',
//     'Curva Abc': 'C',
//     'Estoq Medio Realiz': 3144,
//     'Nivel de Serv Realizado': 92,
//     'estoque medio otim': 13131,
//     'Nivel de Servico Otimi': 4,
//     'Variacao Estoque medio': 4353,
//     'Variacao nivel de Ser': 12,
//     'Nivel Desejado': 0,
//     'Id Categoria': 4
//   },
//   {
//     'Categoria Compac': 'Madeiras',
//     'Curva Abc': 'D',
//     'Estoq Medio Realiz': 123,
//     'Nivel de Serv Realizado': 98,
//     'estoque medio otim': 11214,
//     'Nivel de Servico Otimi': 29,
//     'Variacao Estoque medio': 1313,
//     'Variacao nivel de Ser': 1,
//     'Nivel Desejado': 0,
//     'Id Categoria': 5
//   },
//   {
//     'Categoria Compac': 'Comparcado',
//     'Curva Abc': 'A',
//     'Estoq Medio Realiz': 1,
//     'Nivel de Serv Realizado': 90,
//     'estoque medio otim': 2424,
//     'Nivel de Servico Otimi': 23,
//     'Variacao Estoque medio': 5353,
//     'Variacao nivel de Ser': 2,
//     'Nivel Desejado': 1,
//     'Id Categoria': 6
//   }
// ]
export const DataTable = () => {
  const { data, setSelectedlevelAction } = useOptimizerStorange()

  return (
    <Box>
      <TableContainer>
        <Table size="sm" className="scl-table-grid-v2">
          <Thead bg="#1d5840" color="white" border={10} h={10} fontWeight="700">
            <Tr>
              <Th py={2} fontWeight="700">
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Codigo Nivel
                </Text>
              </Th>
              <Th color="white" py={1} fontWeight="700">
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Nivel
                </Text>
              </Th>
              <Th color="white" py={2} fontWeight="700">
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Est Realizado
                </Text>
              </Th>
              <Th color="white" py={2} fontWeight="700">
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Nivel Serv Realizado
                </Text>
              </Th>
              <Th color="white" py={1} fontWeight="700">
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Est Otimizado
                </Text>
              </Th>
              <Th color="white" py={2} fontWeight="700">
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Nivel Serv Otimizado
                </Text>
              </Th>
            </Tr>
          </Thead>
          <Tbody pb={0}>
            {data?.resumoNivel?.map((row, index) => (
              <Tr
                key={index}
                _hover={{ fontSize: '1.5em', fontWeight: '700' }}
                bg="gray.50"
                onClick={() => {
                  setSelectedlevelAction(row.nivel, null, 1)
                }}
              >
                <Td>{row.codigoNivel}</Td>
                <Td>{row.nivel}</Td>
                <Td> {formatToBRL(row.estoqueMedioRealizado)}</Td>
                <Td>{formatPercent(row.nivelServicoRealizado)} </Td>
                <Td>{formatToBRL(row.estoqueMedioOtimizado)}</Td>
                <Td>{formatPercent(row.nivelServicoOtimizado)} </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export const DataTableOne = () => {
  const { setSelectedlevelAction, settab, data } = useOptimizerStorange()

  return (
    <Box>
      <TableContainer
        borderRadius="lg"
        border="1px"
        borderColor="gray.200"
        maxHeight="500px" // Defina a altura máxima do contêiner da tabela
        overflowY="auto" // Adicione rolagem vertical se o conteúdo exceder a altura máxima
        overflowX="auto" // Adicione rolagem horizontal se o conteúdo exceder a largura
      >
        <Table
          size="sm"
          className="scl-table-grid-v2"
          style={{ position: 'relative' }}
        >
          <Thead
            bg="#1d5840"
            color="white"
            border={10}
            h={10}
            fontWeight="700"
            className="sticky-header"
          >
            <Tr>
              <Th py={2} fontWeight="700"></Th>
              <Th py={2} fontWeight="700">
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Categoria Compac
                </Text>
              </Th>
              <Th color="white" py={2}>
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Curva Abc
                </Text>
              </Th>
              <Th color="white" py={2}>
                {' '}
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Estoq Medio Realiz
                </Text>
              </Th>
              <Th color="white" py={2}>
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Nivel de Serv Realizado
                </Text>
              </Th>
              <Th color="white" py={2}>
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  estoque medio otim
                </Text>
              </Th>
              <Th color="white" py={2}>
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Nivel de Servico Otimi
                </Text>
              </Th>
              <Th color="white" py={2}>
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Variacao Estoque medio
                </Text>
              </Th>
              <Th color="white" py={2}>
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Variacao nivel de Ser
                </Text>
              </Th>
              <Th color="white" py={2}>
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Nivel Desejado
                </Text>
              </Th>
              <Th color="white" py={2}>
                <Text fontWeight="700" color="white" fontSize="14" as="b">
                  Id Categoria
                </Text>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {data.categoriaCompactaEstoque.map((row, index) => (
              <Tr
                key={index}
                _hover={{ fontSize: '1.3em', fontWeight: '700' }}
                bg="gray.50"
                onClick={() => {
                  setSelectedlevelAction(
                    row.categoriaCompactaDescricao,
                    row.curvaABCD,
                    1
                  )
                }}
              >
                <Td>
                  <IconButton
                    m={0}
                    aria-label="Search"
                    icon={<FaEye />}
                    colorScheme="green"
                    variant="simple"
                    size="sm"
                    h={0}
                    onClick={() => {
                      settab(2, row.key)
                    }}
                  />
                </Td>
                <Td>{row.categoriaCompactaDescricao}</Td>
                <Td>{row.curvaABCD}</Td>
                <Td>{formatToBRL(row.estoqueMedioRealizado)}</Td>
                <Td>{formatPercent(row.nivelServicoRealizado)}</Td>
                <Td>{formatToBRL(row.estoqueMedioOtimizado)}</Td>
                <Td>{formatPercent(row.nivelServicoOtimizado)}</Td>
                <Td
                  bg={row.variacaoEstoqueMedio <= 0 ? 'green.100' : 'red.100'}
                >
                  {formatToBRL(row.variacaoEstoqueMedio)}
                </Td>
                <Td
                  bg={row.variacaoNivelServico <= 0 ? 'green.100' : 'red.100'}
                >
                  {formatPercent(row.variacaoNivelServico)}
                </Td>
                <Td>{row.nivelServicoDesejado}</Td>
                <Td>{row.categoriaCompactaId}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  )
}
const LineChart = () => {
  const {
    selectedotimizer,
    resumoData,
    dataTradeOff,
    indexStkOtimizar,
    settab,
    setIndex,
    getDataWithPoint,
    setSelectedlevelAction
  } = useOptimizerStorange()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [selectedPoint, setSelectedPoint] = useState(null)

  // const indexStkOtimizar = findFirstNonNullIndex(dataTradeOff.series[0].data)
  let content: any[] = []

  if (selectedotimizer != null) {
    const content1 = [
      resumoData[0].otimizador < resumoData[0].realizado
        ? {
            name: 'Otimizador',
            data: [
              null,
              resumoData[0].otimizador < resumoData[0].realizado
                ? resumoData[1].otimizador * 100
                : null,
              resumoData[0].otimizador > resumoData[0].realizado
                ? resumoData[1].otimizador * 100
                : null,
              null
            ],
            color: '#04671a'
          }
        : {
            name: 'Realizado',
            data: [
              null,
              resumoData[0].realizado > resumoData[0].otimizador
                ? resumoData[1].realizado * 100
                : null,
              resumoData[0].realizado < resumoData[0].otimizador
                ? resumoData[1].realizado * 100
                : null,
              null
            ],
            color: '#f64223'
          },
      resumoData[0].otimizador < resumoData[0].realizado
        ? {
            name: 'Realizado',
            data: [
              null,
              resumoData[0].realizado < resumoData[0].otimizador
                ? resumoData[1].realizado * 100
                : null,
              resumoData[0].realizado > resumoData[0].otimizador
                ? resumoData[1].realizado * 100
                : null,
              null
            ],
            color: '#f64223'
          }
        : {
            name: 'Otimizador',
            data: [
              null,
              resumoData[0].otimizador < resumoData[0].realizado
                ? resumoData[1].otimizador * 100
                : null,
              resumoData[0].otimizador > resumoData[0].realizado
                ? resumoData[1].otimizador * 100
                : null,
              null
            ],
            color: '#04671a'
          }
    ]
    content = content1
  }

  // new
  const handlePointClick = (
    _event: any,
    _chartContext: any,
    { dataPointIndex, seriesIndex }: any
  ) => {
    const series = dataTradeOff.series[seriesIndex]

    const point = series.data[dataPointIndex]

    if (seriesIndex === 0) {
      if (point !== null && point !== undefined) {
        setSelectedPoint({
          name: series.name,
          index: dataPointIndex,
          value: point
        })
        onOpen()
      }
    }
  }
  const data = {
    options: {
      chart: {
        type: 'sccater',
        events: {
          markerClick: handlePointClick
        }
      },

      xaxis: {
        // min: 0,
        // max: max + 3000000,
        categories: dataTradeOff.categoria,
        labels: {
          formatter: function (value: number) {
            return `R$ ${Number(value)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
          }
        },
        title: {
          text: 'Estoque Médio [Custo (R$)]'
        }
        // labels: {
        //   formatter: function (value: number) {
        //     console.log('aqui2', value)
        //     return `R$ ${value.toLocaleString('pt-BR', {
        //       minimumFractionDigits: 2,
        //       maximumFractionDigits: 2
        //     })}`
        //   }
        // }
      },
      yaxis: {
        labels: {
          formatter: function (value: number) {
            if (value !== null && value !== undefined) {
              return value?.toFixed(2) + ' %'
            }
          }
        },
        title: {
          text: 'Nível de Ruptura (%)'
        },
        tickAmount: 7
      },
      dataLabels: {
        enabled: false
      },

      markers: {
        size: 7,
        // colors: ['#FF0000', '#008000'], // Cores diferentes para cada série
        // strokeColors: ['#FF0000', '#008000'],
        fillOpacity: 1,
        strokeWidth: 2,
        hover: {
          sizeOffset: 6
        },
        discrete: [
          {
            // Posição 3 (índice 2) - Não mostrar marcador
            seriesIndex: 0,
            dataPointIndex: indexStkOtimizar,
            fillColor: 'transparent', // Torna o marcador invisível
            strokeColor: 'transparent' // Torna a borda invisível
          }
        ]
      },
      legend: {
        show: true,
        markers: {
          fillColors: ['#FF0000', '#008000']
        },
        offsetY: 10, // deslocamento vertical
        itemMargin: {
          horizontal: 10, // padding horizontal
          vertical: 12 // padding vertical
        }
      }
    },
    series: content
  }

  const getLevelSelected = (level: any) => {
    if (level <= indexStkOtimizar) {
      return level
    }
    return level - 1
  }

  return (
    <Box w="full" p={5} shadow="md" borderWidth="1px" borderRadius="lg">
      <Chart
        options={data.options as any}
        series={dataTradeOff.series}
        type="line"
        height={340}
        id="chart-one"
        width="100%"
      />
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent bg="white">
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={'gray.200'}
            background={'#1d5840'}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            Ponto Selecionado
          </ModalHeader>
          <ModalCloseButton
            top={1}
            right={1.5}
            textColor={'gray.200'}
            size="lg"
          />
          <ModalBody>
            {selectedPoint && (
              <Text>
                Você selecionou o ponto{' '}
                <b>{getLevelSelected(selectedPoint?.index)}</b>
                <br></br>
                Ruptura % {selectedPoint.value.toFixed(2)}
                <br></br>
                Custo Estoque R${' '}
                {formatToBRL(dataTradeOff.categoria[selectedPoint?.index])}
                {selectedPoint.y}.<br></br>
                <br></br>
                Deseja continuar?
              </Text>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="green"
              onClick={() => {
                settab(2, 1)
                setIndex(2)
                getDataWithPoint(getLevelSelected(selectedPoint?.index))
                onClose()
                setSelectedlevelAction(
                  'Ponto ' + getLevelSelected(selectedPoint?.index),
                  null,
                  1
                )
              }}
            >
              Continuar
            </Button>
            <Button colorScheme="red" onClick={onClose} ml={3}>
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  )

  // const { selectedotimizer, resumoData } = useOptimizerStorange()
  // const realizadoData = [
  //   {
  //     x: resumoData[0].realizado,
  //     y: resumoData[1].realizado.toFixed(2)
  //   }
  // ]
  // const otimizadorData = [
  //   {
  //     x: resumoData[0].otimizador,
  //     y: resumoData[1].otimizador.toFixed(2)
  //   }
  // ]
  // console.log(realizadoData)
  // console.log(otimizadorData)
  // const pointsData = [
  //   { x: 23660701.05067444, y: '0.03' },
  //   { x: 10274022.88707787, y: '0.04' }
  // ]
  // // Encontrar os valores mínimos e máximos para os pontos de dados
  // const xValues = pointsData.map(point => point.x)
  // const minValue = Math.min(...xValues)
  // const maxValue = Math.max(...xValues)
  // // Determinar a largura desejada entre as categorias
  // const widthBetweenCategories = 5000000 // Você pode ajustar conforme necessário
  // // Calcular as categorias intermediárias
  // const xCategories = []
  // for (
  //   let value = minValue;
  //   value <= maxValue;
  //   value += widthBetweenCategories
  // ) {
  //   xCategories.push(value)
  // }
  // // Agora xCategories será ["10000", "20000", "30000", "40000", "50000", "60000"] com base nos valores mínimos e máximos dos seus pontos de dados
  // console.log(xCategories)
  // const data = {
  //   options: {
  //     chart: {
  //       id: 'basic-line'
  //     },
  //     xaxis: {
  //       categories: xCategories
  //     },
  //     markers: {
  //       size: 6
  //     }
  //   },
  //   series: [
  //     {
  //       name: 'Realizado',
  //       data: realizadoData
  //     },
  //     {
  //       name: 'Otimizado',
  //       data: otimizadorData
  //     }
  //   ]
  // }
  // return (
  //   <Box w="full" p={5} shadow="md" borderWidth="1px" borderRadius="lg">
  //     <Chart
  //       options={data.options}
  //       series={data.series}
  //       type="scatter"
  //       height={240}
  //       width={700}
  //     />
  //   </Box>
  // )
}
const CoreOtimizador: FC = () => {
  const { selectedotimizer, dataDefault, dataTradeOffResume } =
    useOptimizerStorange()

  return (
    <>
      {selectedotimizer != null && (
        <>
          <SelectedTableBar
            levelSelection={selectedotimizer.level}
            curve={selectedotimizer.curve}
          />
        </>
      )}

      <Box textAlign="center">
        <Box
          spacing={10}
          padding={2}
          ml={19}
          mr={19}
          shadow="md"
          borderWidth="1px"
        >
          <Stat
            // px={{ base: 2, md: 4 }}
            // py={'5'}
            shadow={'xl'}
            border={'1px solid'}
            borderColor={'gray.800'}
            rounded={'lg'}
          >
            <Flex
              // justifyContent={'space-between'}
              direction="column"
              alignItems="center"
            >
              <Box
                bg="#1d5840"
                color="white"
                width="100%"
                textAlign="center"
                py={2}
                roundedTop="lg"
              >
                <StatLabel
                  bg="#1d5840"
                  fontWeight="700"
                  fontSize="x"
                  isTruncated
                >
                  <Text fontSize="x" textAlign="center" fontWeight={700}>
                    Otimização de Estoque
                  </Text>
                </StatLabel>
              </Box>
              <Box width="100%">
                <LineChart />
              </Box>
            </Flex>
          </Stat>
        </Box>
      </Box>
      <Grid templateColumns="repeat(6, 1fr)" gap={4} mt={6} mb={10}>
        <GridItem colSpan={2} ml={10}>
          <div>
            <ParametrosTable dataDefault={dataDefault} />
          </div>
        </GridItem>
        <GridItem colSpan={4} mr={10}>
          <div>
            <TradeOffResumeTable
              dataTradeOffResume={dataTradeOffResume}
              formatToBRL={formatToBRL}
              title="Resumo"
            />
          </div>
        </GridItem>
      </Grid>
    </>
  )
}

const Otimizador: FC = () => {
  // const { onOpen, onClose, isOpen } = useDisclosure()
  const {
    tabs,
    dataTradeOffWithPoint,
    loadingSecondView,
    indexTab,
    setIndex,
    dataHistoric,
    getHistoric
  } = useOptimizerStorange()

  return (
    <Box>
      <Tabs
        variant="enclosed"
        index={indexTab}
        onChange={index => setIndex(index)}
      >
        <TabList>
          <Tab onClick={getHistoric}>Histórico</Tab>
          <Tab>Visão Geral</Tab>
          {tabs.find(x => x === 2) && (
            <>
              <Tab>Visão Detalhada</Tab>
            </>
          )}
          {tabs.find(x => x === 3) && (
            <>
              <Tab>Detalhe Produto</Tab>
            </>
          )}
        </TabList>
        <TabPanels>
          <TabPanel>
            {dataHistoric.length > 0 ? (
              <>
                <HistoricOtptimizer />
              </>
            ) : (
              <>
                <LayoutEmpty
                  title="Nada encontrado!"
                  message="Ainda não existem otimizações realizadas."
                />
              </>
            )}
          </TabPanel>
          <TabPanel>
            {/* <Box
              maxH={height}
              h="150vh"
              overflowY="auto"
              borderRight="solid 1px"
              borderColor="gray.200"
            > */}
            <CoreOtimizador />
            {/* </Box> */}
          </TabPanel>
          <TabPanel>
            {loadingSecondView ? (
              <LayoutLoader
                title="Recuperando informações..."
                message="Aguarde enquanto buscamos os dados no banco de dados"
              />
            ) : dataTradeOffWithPoint.length === 0 ? (
              <LayoutEmpty
                title="Nada encontrado!"
                message="Filtre sua busca ao lado para obter informações"
              />
            ) : (
              <Box>
                <Core2Otimizador />
              </Box>
            )}
          </TabPanel>
          <TabPanel>
            <Core3Otimizador />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  )
}

export default Otimizador
